import * as React from 'react';
import { useDeviceType } from '../../hooks/deviceType';
import {
    DeviceType,
    PageType,
    Vertical,
    Subvertical,
} from '../../../shared/types/ast';
import { Switch } from '../switch';
import { bannerName } from '../../utils/result';

export type Props = {
    deviceType?: DeviceType;
    vertical?: Vertical;
    subvertical?: Subvertical;
    pageType?: PageType;
};

export default function SwitchBoard(props: Props) {
    const {
        vertical,
        subvertical,
        pageType,
        deviceType: deviceTypeFromServer,
    } = props;
    const deviceType = useDeviceType(deviceTypeFromServer);
    const id = bannerName(deviceType, 1);

    if (vertical === 'travel' && subvertical === 'prepackage') {
        return (
            <Switch
                id={id}
                className=""
                {...props}
                deviceType={deviceType}
                pageType={pageType}
            />
        );
    }

    if (deviceType === 'mobile') {
        let className = 'banners u-pa0 u-mh16';
        if (subvertical === 'currency') {
            className = 'u-pa0';
        }

        return (
            <Switch
                id={id}
                className={className}
                {...props}
                deviceType={deviceType}
                pageType={pageType}
            />
        );
    }
    return null;
}
